/* eslint-disable complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import PRODUCTDETAIL_CONSTANTS from './ProductDetail.constants';
import { DEFAULT_REDUCER_KEY } from '../../../../../utils/cache.util';

const initialState = {
  [DEFAULT_REDUCER_KEY]: null,
  deliveryMethodIndex: 0,
  deliveryMethodIndexCart: 0,
  isSidebarMounted: false,
  activeTabSection: 'features',
  sizeChartModuleX: {},
  additionalPromoModuleXContent: null,
  breadCrumbs: [],
  isDeptClicked: false,
  similarProducts: [],
};

function productDetailReducer(state, action, payload, type) {
  switch (type) {
    case PRODUCTDETAIL_CONSTANTS.SET_MULTIPRODUCT_DETAILS:
    case PRODUCTDETAIL_CONSTANTS.SINGLE_TAB_STORE: {
      return { ...state, ...payload };
    }

    case PRODUCTDETAIL_CONSTANTS.MULTIPACK_SELECTION:
      return { ...state, selectedMultipack: action.payload };

    case PRODUCTDETAIL_CONSTANTS.SET_DISABLE_SELECTED_TAB:
      return { ...state, ...payload };

    case PRODUCTDETAIL_CONSTANTS.SET_SIMILAR_PRODUCTS:
      return {
        ...state,
        similarProducts: action.payload,
      };

    case PRODUCTDETAIL_CONSTANTS.RESET_SIMILAR_PRODUCTS:
      return {
        ...state,
        similarProducts: [],
      };

    case PRODUCTDETAIL_CONSTANTS.OPEN_SIMILAR_PRODUCTS_MODAL:
      return {
        ...state,
        isSimilarProductsModalOpen: true,
      };
    case PRODUCTDETAIL_CONSTANTS.CLOSE_SIMILAR_PRODUCTS_MODAL:
      return {
        ...state,
        isSimilarProductsModalOpen: false,
      };

    default:
      return { ...state };
  }
}

const getPageUrl = (payload) => {
  return typeof payload === 'object' ? '' : payload;
};

const updateModuleXContent = (state, payload, contentKey) => ({
  ...state,
  [contentKey]: payload.content,
});

const handleModuleXContentUpdate = (state, payload, type) => {
  const contentKey =
    type === PRODUCTDETAIL_CONSTANTS.SET_ADDITIONAL_PROMO_MODULEX_CONTENT
      ? 'additionalPromoModuleXContent'
      : 'shippingAndReturnsModuleXContent';
  return updateModuleXContent(state, payload, contentKey);
};

const ProductDetailReducer = (state = initialState, action) => {
  const { payload = {}, type } = action;
  switch (type) {
    case PRODUCTDETAIL_CONSTANTS.SET_PRODUCT_DETAILS: {
      return {
        ...state,
        currentProduct: { ...payload.product },
        breadCrumbs: payload.breadCrumbs,
        alternateStyles: payload?.alternateStyles,
      };
    }
    case PRODUCTDETAIL_CONSTANTS.SET_PRODUCT_DETAILS_DYNAMIC_DATA:
      return {
        ...state,
        currentProductDynamicData: { ...payload.product },
        breadCrumbs: action.payload.breadCrumbs,
      };
    case PRODUCTDETAIL_CONSTANTS.SET_PDP_LOADING_STATE:
      return { ...state, ...payload };
    case PRODUCTDETAIL_CONSTANTS.SET_SYTE_SCRIPT_LOADED:
      return { ...state, ...payload };
    case PRODUCTDETAIL_CONSTANTS.SET_PDP_CALLED_VIA_RECOMMENDATION:
      return { ...state, ...payload };
    case PRODUCTDETAIL_CONSTANTS.LOAD_SOCIAL_PROOF_DATA:
      return { ...state, ...payload };
    case PRODUCTDETAIL_CONSTANTS.CLEAR_SOCIAL_PROOF_DATA:
      return { ...state, socialProofData: null };
    case PRODUCTDETAIL_CONSTANTS.RESET_COUNT_UPDATED:
      return { ...state, countUpdated: false };
    case PRODUCTDETAIL_CONSTANTS.SET_PAGE_URL:
      return { ...state, pageUrl: getPageUrl(payload) };
    case PRODUCTDETAIL_CONSTANTS.SET_ADD_TO_FAVORITE: {
      const productDetailsMap = state.currentProduct;
      const currentProductDynamicDataMap = state.currentProductDynamicData;
      const productMap = currentProductDynamicDataMap
        ? [productDetailsMap, currentProductDynamicDataMap]
        : [productDetailsMap];
      productMap.map((productInfo) => {
        // eslint-disable-next-line no-param-reassign
        productInfo.colorFitsSizesMap = productInfo.colorFitsSizesMap.map((item) => {
          if (item.colorProductId === action.payload.pdpColorProductId) {
            // eslint-disable-next-line no-param-reassign
            item = {
              ...item,
              isFavorite: true,
              newItemId: action.payload.res && action.payload.res.newItemId,
              favoritedCount: action.payload.res && action.payload.res.favoritedCount,
            };
          }
          return item;
        });
        return productInfo;
      });
      return { ...state, countUpdated: true, currentProduct: { ...productDetailsMap } };
    }
    case PRODUCTDETAIL_CONSTANTS.SET_PDP_DISPLAY_PRICE:
      return { ...state, ...payload };
    case PRODUCTDETAIL_CONSTANTS.SELECTED_SIZE_STATUS:
      return { ...state, selectedSizeStatus: payload };
    case PRODUCTDETAIL_CONSTANTS.REMOVE_OUTFIT_ITEM_FROM_FAVORITE: {
      const productDetailsMap = state.currentProduct;
      const currentProductDynamicDataMap = state.currentProductDynamicData;
      const productMap = currentProductDynamicDataMap
        ? [productDetailsMap, currentProductDynamicDataMap]
        : [productDetailsMap];
      productMap.map((productInfo) => {
        // eslint-disable-next-line no-param-reassign
        productInfo.colorFitsSizesMap = productInfo.colorFitsSizesMap.map((item) => {
          // eslint-disable-next-line no-param-reassign
          item = {
            ...item,
            isFavorite: true,
            newItemId:
              action.payload.deleteItemResponse && action.payload.deleteItemResponse.removedItemId,
            favoritedCount:
              action.payload.deleteItemResponse && action.payload.deleteItemResponse.favoritedCount,
          };
          return item;
        });
        return productInfo;
      });
      return { ...state, countUpdated: true, currentProduct: { ...productDetailsMap } };
    }
    case PRODUCTDETAIL_CONSTANTS.SET_REVIEW_DATA:
      return { ...state, currentProduct: { ...state.currentProduct, bazaarVoice: payload } };
    case PRODUCTDETAIL_CONSTANTS.SET_UPDATED_PRODUCT_DETAILS:
      return { ...state, currentProduct: { ...state.currentProduct, ...payload } };
    case PRODUCTDETAIL_CONSTANTS.SET_UPDATED_PRODUCT_DETAILS_DYNAMIC_DATA:
      return {
        ...state,
        currentProductDynamicData: { ...state.currentProductDynamicData, ...payload },
      };
    case PRODUCTDETAIL_CONSTANTS.SET_UPDATED_MULTIPACK_VMP_NONVMP:
      return { ...state, ...payload };
    case PRODUCTDETAIL_CONSTANTS.UPDATE_DELIVERY_METHOD_INDEX:
      if (!payload.isFromCart) {
        return {
          ...state,
          deliveryMethodIndex: payload.deliveryMethodIndex,
          deliveryMethodIndexCart: payload.deliveryMethodIndex,
        };
      }
      return { ...state, deliveryMethodIndexCart: payload.deliveryMethodIndex };
    case PRODUCTDETAIL_CONSTANTS.IS_SIDEBAR_MOUNTED:
      return { ...state, isSidebarMounted: action.payload };
    case PRODUCTDETAIL_CONSTANTS.SET_TAB_SECTION_NAME:
      return { ...state, activeTabSection: action.payload };
    case PRODUCTDETAIL_CONSTANTS.SET_INDEX:
      return { ...state, scrollToIndex: action.payload };
    case PRODUCTDETAIL_CONSTANTS.SET_PLP_PRODUCT_DATA:
      return { ...state, plpProductData: action.payload };
    case PRODUCTDETAIL_CONSTANTS.SET_SLP_PRODUCT_DATA:
      return { ...state, slpProductData: action.payload };
    case PRODUCTDETAIL_CONSTANTS.SET_CART_PRODUCT_DATA:
      return { ...state, cartProductData: action.payload };
    case PRODUCTDETAIL_CONSTANTS.SET_RETURN_SIZECHART_MODULEX_CONTENT:
      return {
        ...state,
        sizeChartModuleX: {
          ...state.sizeChartModuleX,
          [action.payload.brand]: action.payload.content,
        },
      };
    case PRODUCTDETAIL_CONSTANTS.SET_ADDITIONAL_PROMO_MODULEX_CONTENT:
    case PRODUCTDETAIL_CONSTANTS.SET_SHIPPING_AND_RETURNS_MODULEX_CONTENT:
      return handleModuleXContentUpdate(state, payload, type);
    case PRODUCTDETAIL_CONSTANTS.SET_ALTERNATE_STYLES:
      return { ...state, alternateStyles: action.payload };
    case PRODUCTDETAIL_CONSTANTS.FETCH_DYNAMIC_CONTENT_PROMO:
      return { ...state, showDynamicContentLoader: action.payload };
    case PRODUCTDETAIL_CONSTANTS.IS_DEPT_CLICKED:
      return { ...state, isDeptClicked: action.payload };
    case PRODUCTDETAIL_CONSTANTS.IS_STICKY_ATB_LOADED:
      return { ...state, ...action.payload };
    default:
      return productDetailReducer(state, action, payload, type);
  }
};

export default ProductDetailReducer;
